import { AnchorButton } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const SaveButton = ({
  buttonText = 'Save',
  clickHandler = () => {},
  miniVersion = false,
  disabled = false,
}) => {
  return (
    <AnchorButton
      disabled={disabled}
      small={miniVersion}
      minimal={miniVersion}
      intent='primary'
      icon={'floppy-disk'}
      onClick={clickHandler}>
      {!miniVersion && buttonText}
    </AnchorButton>
  );
};

SaveButton.propTypes = {
  buttonText: PropTypes.string,
  clickHandler: PropTypes.func,
  miniVersion: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default SaveButton;
